module.exports = __webpack_public_path__ + "media/application/images/svgs/smile-d692b6b7a47380b333a7acbc44eece1f.svg";